import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        width: "100%",
        marginTop: 40,
        display: "grid",
        [theme.breakpoints.down("desktop")]: {
            marginTop: 24,
        },
    },
    input: {
        display: "grid",
        marginTop: 26,
    },
    link: {
        display: "block",
        marginTop: 32,
        textDecoration: "underline",
        cursor: "pointer",
        padding: "0px 2px",
    },
    termsBox: {
        display: "flex",
        justifyContent: "flex-start",
        alignitems: "center",
        marginTop: 40,
        [theme.breakpoints.down("desktop")]: {
            marginTop: 28,
        },
    },
    checkboxContainer: {
        marginRight: 12,
        transform: "translateY(-3px)",
    },
    buttonContainer: {
        marginTop: 98,
        [theme.breakpoints.down("desktop")]: {
            marginTop: 36,
        },
    },
    message: {
        marginTop: 24,
        [theme.breakpoints.down("desktop")]: {
            marginTop: 28,
        },
    },
    loaderContainer: {
        marginTop: 24,
        width: "100%",
        textAlign: "center",
        [theme.breakpoints.down("desktop")]: {
            marginTop: 28,
        },
    },
}));

export default useStyles;
